export default __webpack_public_path__ + "f72c0f20a8853db819788aac544ab986.png";